
{
  "familyId": "TIJD-12-24",
  "questions": [
    {
      "id": "TIJD-12-24-001",
      "familyId": "TIJD-12-24",
      "module": "Tijd",
      "tier": 7,
      "levelCode": "B7",
      "group": 7,
      "skill": "klokkijken",
      "subSkill": "klok_12_24_notatie",
      "questionType": "multiple_choice",
      "question": "Het is 15:30 op de 24-uursklok. Hoe laat is dat in 12-uursnotatie?",
      "options": ["3:30 's middags", "3:30 's ochtends", "15:30 's middags", "5:30 's middags"],
      "correctAnswer": 0,
      "stimulusAids": [
        { "type": "digitalClock", "data": { "hours": 15, "minutes": 30, "format": "24h" } }
      ],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "24-uurs naar 12-uurs",
            "content": "Na 12:00 trek je 12 af. 15:30 → 15 − 12 = 3. Dus 3:30 's middags. Vóór 12:00 = 's ochtends, na 12:00 = 's middags.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "tijd_12_24_omzetten",
      "variantIndex": 1,
      "citoDifficulty": 0.28,
      "citoDiscrimination": 0.76,
      "pedagogy": { "dok": 2, "misconceptionTags": [] },
      "feedback": {
        "explanationText": "15:30 → 15 − 12 = 3. Het is na 12:00, dus 's middags. Antwoord: 3:30 's middags.",
        "solutionSteps": [
          "15:30 is na 12:00 → 's middags",
          "Trek 12 af: 15 − 12 = 3",
          "Antwoord: 3:30 's middags"
        ],
        "distractorExplanations": {
          "0": "Goed! 15 − 12 = 3, dus 3:30 's middags.",
          "1": "Je dacht waarschijnlijk dat 15:30 's ochtends is. Maar 15:00 is na 12:00, dus het is 's middags. 's Ochtends zou het 3:30 zijn op de 24-uursklok.",
          "2": "Je dacht waarschijnlijk dat je 15:30 gewoon overneemt. Maar in 12-uursnotatie gebruik je getallen van 1 tot 12 met 's ochtends of 's middags.",
          "3": "Je dacht waarschijnlijk dat je 15 − 10 = 5 rekent. Maar je trekt altijd 12 af: 15 − 12 = 3."
        }
      }
    },
    {
      "id": "TIJD-12-24-002",
      "familyId": "TIJD-12-24",
      "module": "Tijd",
      "tier": 7,
      "levelCode": "B7",
      "group": 7,
      "skill": "klokkijken",
      "subSkill": "klok_12_24_notatie",
      "questionType": "multiple_choice",
      "question": "Het is 8 uur 's avonds. Hoe schrijf je dat in 24-uursnotatie?",
      "options": ["20:00", "22:00", "08:00", "18:00"],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "clock",
          "showWhen": "wrong",
          "data": { "hours": 20, "minutes": 0 }
        },
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "12-uurs naar 24-uurs",
            "content": "'s Middags en 's avonds: tel 12 erbij. 8 uur 's avonds → 8 + 12 = 20:00. 's Ochtends blijft het getal hetzelfde.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "tijd_12_naar_24",
      "variantIndex": 2,
      "citoDifficulty": 0.30,
      "citoDiscrimination": 0.75,
      "pedagogy": { "dok": 2, "misconceptionTags": [] },
      "feedback": {
        "explanationText": "8 uur 's avonds → tel 12 erbij: 8 + 12 = 20. Antwoord: 20:00.",
        "solutionSteps": [
          "'s Avonds → tel 12 erbij",
          "8 + 12 = 20",
          "Antwoord: 20:00"
        ],
        "distractorExplanations": {
          "0": "Goed! 8 + 12 = 20:00.",
          "1": "Je hebt waarschijnlijk te veel opgeteld: 8 + 14 = 22:00. Maar 's avonds tel je precies 12 erbij: 8 + 12 = 20:00, niet 22:00.",
          "2": "Je dacht waarschijnlijk dat 08:00 klopt. Maar 08:00 is 8 uur 's ochtends. 's Avonds: 8 + 12 = 20:00.",
          "3": "Je dacht waarschijnlijk dat je 10 erbij telt. Maar je telt altijd 12 erbij: 8 + 12 = 20, niet 18."
        }
      }
    },
    {
      "id": "TIJD-12-24-003",
      "familyId": "TIJD-12-24",
      "module": "Tijd",
      "tier": 7,
      "levelCode": "B7",
      "group": 7,
      "skill": "klokkijken",
      "subSkill": "klok_12_24_notatie",
      "questionType": "multiple_choice",
      "question": "Het is kwart voor 8 's avonds. Hoe schrijf je dat in 24-uursnotatie?",
      "options": ["19:45", "07:45", "17:45", "21:45"],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "12-uurs naar 24-uurs",
            "content": "'s Middags en 's avonds: tel 12 erbij. Kwart voor 8 is 7:45. 7:45 + 12 uur = 19:45.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "tijd_12_naar_24_kwart",
      "variantIndex": 3,
      "citoDifficulty": 0.35,
      "citoDiscrimination": 0.77,
      "pedagogy": { "dok": 2, "misconceptionTags": [] },
      "feedback": {
        "explanationText": "Kwart voor 8 is 7:45. Omdat het 's avonds is, tel je er 12 uur bij op: 7 + 12 = 19. Het is dus 19:45.",
        "solutionSteps": [
          "Kwart voor 8 = 7:45",
          "'s Avonds → tel 12 erbij",
          "7 + 12 = 19",
          "Antwoord: 19:45"
        ],
        "distractorExplanations": {
          "0": "Goed! 7:45 + 12 uur = 19:45.",
          "1": "Je dacht waarschijnlijk aan kwart voor 8 's ochtends. Maar het is 's avonds, dus je moet er 12 uur bij optellen: 19:45.",
          "2": "Je dacht waarschijnlijk aan 5 uur (17:45). Maar 7 + 12 = 19, dus 19:45.",
          "3": "Je dacht waarschijnlijk aan kwart voor 10 (21:45). Maar 7 + 12 = 19, dus 19:45."
        }
      }
    },
    {
      "id": "TIJD-12-24-004",
      "familyId": "TIJD-12-24",
      "module": "Tijd",
      "tier": 7,
      "levelCode": "B7",
      "group": 7,
      "skill": "klokkijken",
      "subSkill": "klok_12_24_notatie",
      "questionType": "multiple_choice",
      "question": "Het is 12:00 op de 24-uursklok. Hoe laat is dat in 12-uursnotatie?",
      "options": ["12:00 's middags", "0:00 's middags", "12:00 's ochtends", "0:00 's nachts"],
      "correctAnswer": 0,
      "stimulusAids": [
        { "type": "digitalClock", "data": { "hours": 12, "minutes": 0, "format": "24h" } }
      ],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "12:00 en 0:00",
            "content": "12:00 (24-uurs) = 12:00 's middags (12-uurs). 0:00 (24-uurs) = 12:00 's nachts (middernacht). Let op: 12:00 is een uitzondering — je trekt geen 12 af!",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "tijd_12_24_uitzondering",
      "variantIndex": 4,
      "citoDifficulty": 0.38,
      "citoDiscrimination": 0.71,
      "pedagogy": { "dok": 2, "misconceptionTags": [] },
      "feedback": {
        "explanationText": "12:00 in 24-uursnotatie = 12:00 's middags. Dit is een uitzondering: je trekt geen 12 af (12 − 12 = 0, maar we schrijven 12:00, niet 0:00).",
        "solutionSteps": [
          "12:00 (24-uurs) = twaalf uur 's middags",
          "Uitzondering: we schrijven 12:00, niet 0:00",
          "0:00 (24-uurs) = middernacht = 12:00 's nachts"
        ],
        "distractorExplanations": {
          "0": "Goed! 12:00 = 12 uur 's middags.",
          "1": "Je dacht waarschijnlijk dat 12 − 12 = 0, dus 0:00. Maar 12:00 is een uitzondering — we schrijven 12:00 's middags, niet 0:00.",
          "2": "Je dacht waarschijnlijk dat 12:00 's ochtends is. Maar 12:00 is precies het begin van de middag. 's Ochtends is vóór 12:00.",
          "3": "Je dacht waarschijnlijk dat 0:00 's nachts hetzelfde is als 12:00. Maar 0:00 = middernacht, en 12:00 = 's middags. Dat zijn 12 uur verschil."
        }
      }
    },
    {
      "id": "TIJD-12-24-005",
      "familyId": "TIJD-12-24",
      "module": "Tijd",
      "tier": 7,
      "levelCode": "B7",
      "group": 7,
      "skill": "klokkijken",
      "subSkill": "klok_12_24_notatie",
      "questionType": "fill_in",
      "question": "Het is 4 uur 's middags. Schrijf dit in 24-uursnotatie (bijv. 14:00). Typ je antwoord.",
      "options": [],
      "correctAnswer": 0,
      "data": {
        "acceptedAnswers": ["16:00", "16.00"],
        "caseSensitive": false,
        "placeholder": "??:00"
      },
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "clock",
          "showWhen": "wrong",
          "data": { "hours": 16, "minutes": 0 }
        },
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "12-uurs naar 24-uurs",
            "content": "'s Middags: tel 12 erbij. 4 uur 's middags → 4 + 12 = 16:00.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "tijd_12_24_invullen",
      "variantIndex": 5,
      "citoDifficulty": 0.30,
      "citoDiscrimination": 0.75,
      "pedagogy": { "dok": 2, "misconceptionTags": [] },
      "feedback": {
        "explanationText": "4 uur 's middags → tel 12 erbij: 4 + 12 = 16. Antwoord: 16:00.",
        "solutionSteps": [
          "'s Middags → tel 12 erbij",
          "4 + 12 = 16",
          "Antwoord: 16:00"
        ]
      }
    }
  ]
}
